import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';

@createModule('Definitionlist')
/**
 * definitionlist module implementation.
 *
 * @author Heiko Frosch <heiko.frosch@namics.com>
 */
export class Definitionlist extends TerrificSpec {
	start(resolve: Function) {
		resolve();
	}
	stop() {}
	_triggerChangeEvent() {
		triggerPublicEvent(PublicEvents.uxChange, this, this._ctx);
	}
}
